// Setting Vue Router

// Import
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/routes/routes";
import store from "@/store";


const router = new VueRouter({
    routes: routes,
    //mode: 'history',
    linkExactActiveClass: "nav-item active",
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});

Vue.use(VueRouter);

/**
 * Filtering linking.
 * Each routing link is filtered based on the authentication.
 * the routes contain a "auth" field in the "meta" props that provides the rules to
 * access that routes:
 *  - requiresAuth if you need authentication
 *  - admin if that routes is accessible only by an admin
 */
router.beforeEach((to, from, next) => {
    let userInfo = store.getters["UserState/getUserInfo"];
    let settingsFilter = store.getters["UserState/getSettings"].settingsFilter;
    let defaultPath = store.getters["AppState/getNavigationData"].defaultPath;

    console.debug("Router beforeEach  <- from: ", from);
    console.debug("Router beforeEach  -> to: ", to);

    if(typeof ga !== "undefined"){
        console.debug("GA", to.fullPath)
        ga('set', 'page', to.fullPath);
        ga('send', 'pageview');
    }
    // If the user attempts to go to a page that requires authentication then do some checks,
    // else confirm the navigation
    //console.log('Router beforeEach - requiresAuth: ', to.meta.auth.requiresAuth);
    if (to.matched.some(record => record.meta.auth.requiresAuth)) {
        // If the user if authenticated then do some checks,
        // else redirect to the /login page
        if (userInfo.isLogged === true) {
            // First of all, filter the routes that have been filtered by settings
            if (to.matched.some(record => record.meta.id)) {
                if (!settingsFilter.includes(to.meta.id)) {
                    console.debug("ROUTER - beforeEach / FILTER - [CONFIRM NAV] - page is not FILTERED");
                    // If the "to" page requires an authentication check user role
                    //    and If userRole is in to.meta.auth.acceptedRoles, then confirm the navigation
                    //  else deny the access
                    if (to.matched.some(record => record.meta.auth.acceptedRoles)) {
                        if (to.meta.auth.acceptedRoles.includes(userInfo.role)) {
                            console.debug("ROUTER - beforeEach / ROLE - [CONFIRM NAV] - the page requires " +
                                to.meta.auth.acceptedRoles + " and userRole is " + userInfo.role + ".");
                            next();
                        } else {
                            console.debug("ROUTER - beforeEach / ROLE - [DENY NAV] - the page requires " +
                                to.meta.auth.acceptedRoles + " but userRole is " + userInfo.role + ".");
                            next(false);
                        }
                    }
                } else {
                    console.debug("ROUTER - beforeEach / FILTER - [DENY NAV] - page is FILTERED");
                    // USER ROLE
                    if (defaultPath[userInfo.role] !== undefined) {
                        next({
                            path: defaultPath[userInfo.role],
                        });
                    } else {
                        next(false);
                    }
                }
            }
        } else {
            if(to.path.includes("oic11")){
                next({
                    path: "/oic11/results",
                });
            } else
            next({
                path: "/", // go to / and then to /homepage
            });
        }
    } else {
        next();
    }
});

export default router;
